"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Declarations = void 0;
class Declarations {
    db = new Map();
    filterByRange(sentenceTextRange, includePartialOverlap) {
        const declarations = new Declarations();
        for (const declaration of this.db.values()) {
            if (includePartialOverlap) {
                if (declaration.scope.some(scopeRange => (((scopeRange.start.sentenceIndex < sentenceTextRange.end.sentenceIndex)
                    || ((scopeRange.start.sentenceIndex === sentenceTextRange.end.sentenceIndex)
                        && (scopeRange.start.textOffset < sentenceTextRange.end.textOffset)))
                    && ((sentenceTextRange.start.sentenceIndex < scopeRange.end.sentenceIndex)
                        || ((sentenceTextRange.start.sentenceIndex === scopeRange.end.sentenceIndex)
                            && (sentenceTextRange.start.textOffset < scopeRange.end.textOffset)))))) {
                    declarations.add(declaration);
                }
            }
            else {
                if (declaration.scope.some(scopeRange => (((scopeRange.start.sentenceIndex < sentenceTextRange.start.sentenceIndex)
                    || ((scopeRange.start.sentenceIndex === sentenceTextRange.start.sentenceIndex)
                        && (scopeRange.start.textOffset <= sentenceTextRange.start.textOffset)))
                    && ((sentenceTextRange.end.sentenceIndex < scopeRange.end.sentenceIndex)
                        || ((sentenceTextRange.end.sentenceIndex === scopeRange.end.sentenceIndex)
                            && (sentenceTextRange.end.textOffset <= scopeRange.end.textOffset)))))) {
                    declarations.add(declaration);
                }
            }
        }
        return declarations;
    }
    values() {
        return [...this.db.values()].sort((a, b) => -(a.attr.name.length - b.attr.name.length));
    }
    add(declaration) {
        this.db.set(declaration.attr.declarationID, declaration);
    }
    get length() {
        return this.db.size;
    }
    get(declarationID) {
        return this.db.get(declarationID);
    }
}
exports.Declarations = Declarations;
//# sourceMappingURL=declarations.js.map